module.exports = __webpack_public_path__ + "static/img/hx1.c46a931.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/hx1.png
// module id = /wLW
// module chunks = 1